import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class CountdownComponent extends Component {
  requiredRefs = ['days', 'hours', 'minutes', 'seconds'];
  #interval = null;
  #io = null;

  connectedCallback() {
    super.connectedCallback();
    if (prefersReducedMotion()) {
      this.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
    } else {
      this.#io = new IntersectionObserver((entries) => {
        for (const e of entries) if (e.isIntersecting) { e.target.classList.add('is-visible'); this.#io?.unobserve(e.target); }
      }, { rootMargin: '0px 0px -10% 0px' });
      this.querySelectorAll('.reveal').forEach((el) => this.#io.observe(el));
    }
    this.#startTimer();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#interval) clearInterval(this.#interval);
    this.#io?.disconnect();
  }

  updatedCallback() {
    super.updatedCallback?.();
    if (this.#interval) clearInterval(this.#interval);
    this.#startTimer();
  }

  #pad(n) { return String(n).padStart(2, '0'); }

  #startTimer() {
    const end = new Date(this.dataset.end).getTime();
    if (isNaN(end)) return;

    const tick = () => {
      const diff = Math.max(0, end - Date.now());
      const { days: d, hours: h, minutes: m, seconds: s } = this.refs;
      if (d) d.textContent = this.#pad(Math.floor(diff / 86400000));
      if (h) h.textContent = this.#pad(Math.floor((diff % 86400000) / 3600000));
      if (m) m.textContent = this.#pad(Math.floor((diff % 3600000) / 60000));
      if (s) s.textContent = this.#pad(Math.floor((diff % 60000) / 1000));
      if (diff === 0) { clearInterval(this.#interval); this.#interval = null; }
    };

    tick();
    this.#interval = setInterval(tick, 1000);
  }
}

if (!customElements.get('countdown-component')) {
  customElements.define('countdown-component', CountdownComponent);
}
